module.exports = __webpack_public_path__ + "static/bg-stationary@2x-b0dfc5461df6e7cb03bff911f578efcd.png";